/**
 * @generated SignedSource<<48a99e09d4bfdabb127d893c80609b4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsTaskDependencies_viewer$data = {
  readonly actualPersonId: string | null;
  readonly id: string;
  readonly company: {
    readonly id: string;
    readonly cascadeDependencyDates: boolean | null;
  } | null;
  readonly " $fragmentType": "SettingsTaskDependencies_viewer";
};
export type SettingsTaskDependencies_viewer$key = {
  readonly " $data"?: SettingsTaskDependencies_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SettingsTaskDependencies_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SettingsTaskDependencies_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cascadeDependencyDates",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "1d93932786cc15c2c4a2f4499791b99d";

export default node;
